import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { AuthProvider } from '../auth/AuthProvider'
import { useAuth } from '../auth/useAuth'
import { Login } from '../pages/Login'
import { appRoutes } from './routes'
import { SESSIONLESS_PATHS } from '../lib/routes'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
})

const router = createBrowserRouter(appRoutes)

function Gate() {
  const { t } = useTranslation()
  const { status } = useAuth()
  const path = window.location.pathname

  // Auth-handoff routes render regardless of session status (the account
  // choice too: it runs on the pending-login cookie, before any session).
  if (SESSIONLESS_PATHS.includes(path)) {
    return <RouterProvider router={router} />
  }

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg-app)] text-[var(--text-tertiary)] text-[13px]">
        {t('common.loading')}
      </div>
    )
  }
  if (status === 'unauthenticated') {
    return <Login />
  }
  return <RouterProvider router={router} />
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </QueryClientProvider>
  )
}
